import React from 'react';
import parse from 'html-react-parser';

import type { AdvancedCopyBlockProps } from 'src/components/molecules/AdvancedCopyBlock/AdvancedCopyBlock';
import { AdvancedCopyBlock } from 'src/components/molecules/AdvancedCopyBlock/AdvancedCopyBlock';
import { SectionContainer } from 'src/components/molecules/SectionContainer/SectionContainer';
import { trackImpression } from 'src/tracking/common/trackImpression';
import { trackLinkClick } from 'src/tracking/components/copyBlock';
import type { TrackingContext } from 'src/types/TrackingContext';
import * as styles from './AdvancedCopyBlockSection.style';

export interface AdvancedCopyBlockSectionProps extends AdvancedCopyBlockProps {
  children: string;
  trackingPosition?: number;
  trackingTitle: string;
}

export const AdvancedCopyBlockSection = ({
  children,
  trackingPosition,
  trackingTitle,
}: AdvancedCopyBlockSectionProps) => {
  const trackingContext: TrackingContext = {
    trackingPosition,
    trackingTitle,
    trackingContentType: 'Advanced copy block',
  };

  return (
    <SectionContainer
      columnsL={8}
      columnsM={10}
      columnsXL={6}
      maxWidth="full"
      wrapperStyles={styles.wrapper}
    >
      <AdvancedCopyBlock
        onLinkClick={(e: React.MouseEvent) => trackLinkClick(e, trackingContext)}
        onVisible={() => trackImpression(trackingContext)}
      >
        {parse(children)}
      </AdvancedCopyBlock>
    </SectionContainer>
  );
};
